module.exports = __webpack_public_path__ + "img/KDV-min.fb2653ef.png";